import { Button, Modal } from 'antd'
import React, { useState } from 'react'
import labor1 from '../Components/fayl/laboratoriya/1.pdf'
import labor2 from '../Components/fayl/laboratoriya/2.pdf'
import labor3 from '../Components/fayl/laboratoriya/3.pdf'
import labor4 from '../Components/fayl/laboratoriya/4.pdf'
import labor5 from '../Components/fayl/laboratoriya/5.pdf'



export const Labaratoriya = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    return (
        <div className="card" > 
            <Button className='button' onClick={showModal}>
                Laboratoriya mashg'ulotlari
            </Button>
            <Modal
                className="custom-modal"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null}> <br /><hr />
<div className='button-container'>
                <Button className='button'>
                    <a href={labor1}>1-laboratoriya mashg'ulot</a>
                </Button><Button className='button'>
                    <a href={labor2}>2-laboratoriya mashg'ulot</a>
                </Button><Button className='button'>
                    <a href={labor3}>3-laboratoriya mashg'ulot</a>
                </Button><Button className='button'>
                    <a href={labor4}>4-laboratoriya mashg'ulot</a>
                </Button><Button className='button'>
                    <a href={labor5}>5-laboratoriya mashg'ulot</a>
                </Button>

</div> <hr /> <br />

            </Modal>
        </div>
    )
}
